/**
 * Column-resize zoom detection, shared by V1 `FlowTable` and V2
 * `LedgerTable` (Codex cdx3 #3).
 *
 * Both resize handlers derive the effective CSS `zoom` from a header as
 * `getBoundingClientRect().width / offsetWidth`. `offsetWidth` is rounded
 * to an integer, so an UNZOOMED header with a fractional layout width
 * (253.5625px → offsetWidth 254) reads ≈0.998 rather than 1 — enough to
 * shift a long drag by a pixel. A ratio within `UNIT_ZOOM_TOLERANCE` of 1
 * is that rounding artefact, never a real zoom (the V2 shell's `V2_ZOOM`,
 * `shell-next/zoom.ts`, is the only intentional one), so it snaps to
 * exactly 1.
 */
const UNIT_ZOOM_TOLERANCE = 0.02;

export function snapUnitZoom(zoom: number): number {
  return Math.abs(zoom - 1) < UNIT_ZOOM_TOLERANCE ? 1 : zoom;
}
